import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import Section from "interfaces/Section";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import SectionVendor from "../../interfaces/SectionVendor";

interface RouteParams {
    id: number;
}

interface State {
    isLoading: boolean;
    errorMessage?: string;
    data: Section;
}

export default class View extends React.Component<
    RouteComponentProps<RouteParams>,
    State
> {
    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);

        this.state = {
            isLoading: true,
            errorMessage: undefined,
            data: {
                id: 0,
                name: "",
                sectionVendors: [],
            },
        };
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }
        var vendors = [];
        for (let i = 0; i < this.state.data.sectionVendors.length; i++) {
            vendors.push(
                <SectionVendor key={i} vendorData={this.state.data.sectionVendors[i]} />
            );
        }
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/sections">Categories</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>
                            {this.state.data.name}
                        </BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <h3 className="card__title">{this.state.data.name}</h3>
                    <div className="box">
                        <div className="full-width">
                            <div className="field-group">
                                <span className="field-label">ID</span>
                                <span className="field-item">{this.state.data.id}</span>
                            </div>
                            <div className="field-group">
                                <span className="field-label">Category Name</span>
                                <span className="field-item">{this.state.data.name}</span>
                            </div>
                            <div className="field-group">
                                <span className="field-label">Code</span>
                                <span className="field-item">{this.state.data.code}</span>
                            </div>
                            <div className="field-group">
                                <span className="field-label">Description</span>
                                <span className="field-item">
                                    {this.state.data.description}
                                </span>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="field-group">
                                        <span className="field-label">Price 1</span>
                                        <span className="field-item">
                                            {this.state.data.listPricePercentage
                                                ? this.state.data.listPricePercentage + " %"
                                                : ""}
                                        </span>
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Price 2</span>
                                        <span className="field-item ">
                                            {this.state.data.ourListPricePercentage
                                                ? this.state.data.ourListPricePercentage + " %"
                                                : ""}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="field-group">
                                        <span className="field-label">Price 3</span>
                                        <span className="field-item ">
                                            {this.state.data.marketCostPercentage
                                                ? this.state.data.marketCostPercentage + " %"
                                                : ""}
                                        </span>
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Price 4</span>
                                        <span className="field-item ">
                                            {this.state.data.price4Percentage
                                                ? this.state.data.price4Percentage + " %"
                                                : ""}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <h5 className="section-seprate">Vendor Information</h5>
                            {vendors}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch(
                "sections/" + this.props.match.params.id,
                undefined,
                true
            );
            if (response.ok) {
                let data = (await response.json()) as Section;
                this.setState({
                    isLoading: false,
                    data: data,
                });

                document.title = `${this.state.data.name} - Category - ${SITE_NAME}`;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    errorMessage: errorText,
                });
            }
        }
    }
}
interface SectionVendorProps {
    vendorData: SectionVendor;
}

const SectionVendor: React.FC<SectionVendorProps> = ({
    vendorData,
    ...rest
}) => {
    return (
        <div>
            <div className="row">
                <div className="field-group col-sm-3">
                    <span className="field-label">Vendor #</span>
                    <span className="field-item">{vendorData.vendorNo}</span>
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">Vendor Name</span>
                    <span className="field-item">{vendorData.vendorName}</span>
                </div>
                <div className="field-group col-sm-3">
                    <span className="field-label">Is Primary</span>
                    <span className="field-item">{vendorData.isPrimary.toString()}</span>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./ClientApp/components/sections/View.tsx